import {isInViewport} from '../helpers/ElementHelper';

export class EventSingleComponent {
  container;

  mtsSectionContainer;

  mtsSectionState = {
    top: 0
  };

  constructor() {
    this.container = document.querySelector('body.single-event');
    this.mtsSectionContainer = document.querySelector('.js-mts-section');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.initMtsSection();

    this.addEventListeners();
  }

  initMtsSection() {
    if (!this.mtsSectionContainer) {
      return;
    }

    this.mtsSectionState.top = this.mtsSectionContainer.offsetTop;

    this.toggleActive();
    this.toggleFixed();
  }

  addEventListeners() {
    window.addEventListener('scroll', () => this.windowScrollHandler());
    window.addEventListener('resize', () => this.windowResizeHandler());
  }

  windowScrollHandler() {
    if (this.mtsSectionContainer) {
      this.mtsScrollChangedHandler();
    }
  }

  windowResizeHandler() {
    if (!this.mtsSectionContainer) {
      return;
    }

    this.mtsSectionContainer.classList.remove('fixed');
    this.mtsSectionContainer.classList.add('active');

    this.mtsSectionState.top = this.mtsSectionContainer.offsetTop;

    this.toggleActive();
    this.toggleFixed();
  }

  mtsScrollChangedHandler() {
    this.toggleActive();
    this.toggleFixed();
  }

  mtsWindowResizeHandler() {
    this.initMtsSection();
  }

  toggleFixed() {
    window.scrollY < this.mtsSectionState.top
      ? this.mtsSectionContainer.classList.remove('fixed')
      : this.mtsSectionContainer.classList.add('fixed');
  }

  toggleActive() {
    isInViewport(this.mtsSectionContainer)
      ? this.mtsSectionContainer.classList.add('active')
      : this.mtsSectionContainer.classList.remove('active');
  }
}